export const MOCK_VACATION_LEGAL_MODAL_DIALOG_LINK = {
  service_fees_link: '/legal/fees/',
  terms_and_condition_link: '/vacations/terms-conditions/#/',
};
